

import { Switch } from '@mui/material';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { fetchAccounts } from 'slices/accountSlice';
import { accountsSelector } from 'slices/accountSlice';
import { appointmentsSelector } from 'slices/appointmentSlice';
import moment from "moment";
import { fetchDepartments } from 'slices/departmentsSlice';
import { departmentsSelector } from 'slices/departmentsSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import { hospitalSelector } from 'slices/hospitalSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { languageSelector } from 'slices/languageSlice';
import { fetchTypes } from 'slices/typeSlice';
import { typesSelector } from 'slices/typeSlice';

const serviceOption = [
    { value: 'in_person', label: 'In Person' },
    { value: 'otp_preschedule', label: 'OTP Preschedule' },
    { value: 'vide_remote_interpretation', label: 'Video Remote Interpretation' },
    { value: 'opi_on_demand', label: 'OPI On Demand' },
]


const ConfirmDataStep = ({ item, handleSubmit, watch, onClose, control, dispatch, ConfirmData, popupType }) => {
    const { error, loader } = useSelector(appointmentsSelector);
 
    return (
        <>
            <div className='step_cards step_5'>
                <h2>Confirm Data </h2>

                <div className="Table_data_show w-100">
                    <table>
                        <tbody>
                            <tr>
                                <td>Client</td>
                                <td>{ConfirmData?.clientName}</td>
                            </tr>
                            {ConfirmData?.subClientName &&
                                <tr>
                                    <td>Sub Account</td>
                                    <td>{ConfirmData?.subClientName}</td>
                                </tr>
                            }
                            <tr>
                                <td>Appointment Type:</td>
                                <td>{watch("type")}</td>
                            </tr>
                            <tr>
                                <td>Timezone:</td>
                                <td>{ConfirmData?.timezone?.label}</td>
                            </tr>
                            <tr>
                                <td>Language</td>
                                <td>{ConfirmData?.Language}</td>
                            </tr>
                            <tr>
                                <td>Date</td>
                                <td>{ moment(watch("date"), 'YYYY-MM-DD').format('MMM D, YYYY') || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td>Start time</td>
                                <td> { moment(watch("start_time"), 'hh:mm A').format('hh:mm A') || 'N/A'}</td>
                            </tr>
                            <tr>
                                <td>Estimated Duration</td>
                                <td>{watch("estimated_duration")} {watch('estimated_duration_unit')}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {watch("type") == "Video Remote Interpretation" && <div className="row-primary">
                    <h2>Video Call Link

                        {/* <small> (Optional)</small> */}
                    </h2>
                    <Controller
                        name="video_link"
                        control={control}
                        render={({ field }) => (
                            <textarea
                                className="type_inp input-in"
                                {...field}
                                placeholder='Video Call Link ..'
                                required
                            >
                            </textarea>

                        )}
                    />
                </div>}


                <div className="row-primary">
                    <h2 >Auto Assign</h2>

                    <Controller
                        name="auto_assign"
                        control={control}
                        render={({ field }) =>
                            <Switch sx={{ marginTop: 1 }} checked={field.value == 1 ? true : false} onChange={() => field.onChange(field.value == 1 ? 0 : 1)} />


                        }
                    />
                </div>

                {error?.errors?.type?.map((error) => (
                    <ErrorMessage text={error} />
                ))}

                <div className="Form-footer">
                    <button type="button" className="Cancle_button" onClick={onClose}>Cancel</button>
                    <SubmitButton
                        btnText= {item?.id ? popupType === "copy"  ? "Copy " : "Update" : "Create"}
                        handleSubmit={handleSubmit}

                        loader={loader}
                    />
                </div>
            </div>
        </>
    )
};



export default ConfirmDataStep